import { Component, OnInit, Input, Output, EventEmitter, ElementRef, ViewChild, OnDestroy } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { RxMethods } from '../../services/rxjs.service';
import { Utils } from '../../services/utils.service';

@Component({
  selector: 'app-date-time-picker',
  templateUrl: './date-time-picker.component.html',
  styleUrls: ['./date-time-picker.component.css']
})
export class DateTimePickerComponent implements OnInit, OnDestroy {
  @Input() configs: any;
  @Input() formGroup: FormGroup;
  @Output() onSelect?: any = new EventEmitter();
  @Output() onValueChanged?: any = new EventEmitter();
  @Output() afterPickerOpened?: any = new EventEmitter();
  onItemChanged = this.rxMethods.createSubjectService();
  timeoutId: any;
  inputElem: ElementRef;
  @ViewChild('dateTimePicker') datePciker;
  dateObj: any;
  dateString: any;
  selectedDate: any;
  isInputFocused = false;
  defaultDt = '';

  constructor(private rxMethods: RxMethods,
    private utils: Utils) { }

  onDatePicked(date) {
    const scope = this;
    date = this.configs['pickerType'] === 'timeOnly' ? this.utils.formatDate(date, 'HH:mm') : this.utils.formatDate(date);
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }
    this.timeoutId = setTimeout(function () {
      if (scope.configs['isGrid']) {
        scope.onItemChanged.next(date);
      } else {
        scope.formGroup.controls[scope.configs['id']].patchValue(date);
        scope.onSelect.emit({ date: date, template: scope.configs });
        scope.datePciker.overlayVisible = false;
      }
    }, 500);
  }

  onDateTimeChange(event) {
    if (this.isInputFocused) {
      this.onBlurInput(event.input);
      if (this.configs['isGrid']) {
        this.onItemChanged.next(this.dateString ? this.dateString : '');
      }
      this.isInputFocused = false;
    } else {
      // if (this.configs['isGrid']) {
      if (!event.value) {
        this.onItemChanged.next(this.dateString);
        return;
      }
      if (this.configs['pickerType'] === 'both') {
        this.dateString = this.utils.formatDate(event.value, 'DD/MM/YYYY HH:mm');
      } else if (this.configs['pickerType'] === 'calendar') {
        this.dateString = this.utils.formatDate(event.value, 'DD/MM/YYYY');
      }
      if (this.configs['pickerType'] === 'timer') {
        this.dateString = this.utils.formatDate(event.value, 'HH:mm');
      }
      this.onItemChanged.next(this.dateString ? this.dateString : '');
    }
    if (this.configs.onSelect) {
      this.configs.onSelect(this.dateString, event.value, this.configs.scope, this.configs.id);
    }
  }

  onAfterPickerClosed() {
    if (this.configs['isGrid']) {
      let date  = this.dateString;
      if(date == undefined && this.configs.pickerType !='timer'){
        date = this.utils.formatDate(new Date,'DD/MM/YYYY');
      }
      this.onItemChanged.next(date);
      this.dateString = '';
    }
  }

  onClearClick() {
    if (this.configs['isGrid']) {
      this.configs['model'] = '';
      this.onItemChanged.next(null);
    } else {
      this.formGroup.controls[this.configs['id']].patchValue('');
    }
  }

  onDateTimeInput($event) {
    this.dateObj = $event.value ? new Date($event.value) : '';
    if ($event.value) {
      this.selectedDate = new Date(+$event.value);
    }
    if (this.configs['isGrid']) {
      this.onBlurInput($event.input);
      // this.onItemChanged.next(this.dateString ? this.dateString : ' ');
    }
  }

  validateDate(event) {
    let date, day, month, year, getTotalDaysForMonth;
    if (this.dateObj) {
      date = this.dateObj;
      day = date.getDate();
      month = date.getMonth();
      year = date.getFullYear();
    } else {
      const value = event.target.value;
      const dateObj = value.split(',');
      const dateString = dateObj[0].split('/');
      day = parseInt(dateString[0]);
      month = parseInt(dateString[1]);
      year = parseInt(dateString[2]);

    }
    getTotalDaysForMonth = new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();
  }

  checkValidDate(dateText) {
    const dateParts = dateText.split('/');
    const date = new Date(+dateParts[2], +dateParts[1] - 1, +dateParts[0]);
    return ((date instanceof Date) ? date : false);
  }

  checkValidFormatString(text) {
    let date;
    const slashCount = text.match(new RegExp("/", 'g'));
    const isTimeExists = text.match(new RegExp(":", 'g'));
    if (slashCount && slashCount.length === 2) {
      if (this.configs['pickerType'] === 'both') {
        const date = this.checkValidDate(text);
        if (date && isTimeExists) {
          return date;
        } else {
          return;
        }
      } if (this.configs['pickerType'] === 'calendar') {
        const date = this.checkValidDate(text);
        if (date) {
          return date;
        } else {
          return;
        }
      }
    }
    if (isTimeExists && isTimeExists.length && this.configs['pickerType'] === 'timer') {
      const timeParts = text.split(':');
      if (timeParts.length > 1) {
        const dateTime = new Date();
        dateTime.setHours(parseInt(timeParts[0]));
        dateTime.setMinutes(parseInt(timeParts[1]));

        return dateTime;
      }
    }

  }

  getGridInputDate(inputTxt, today) {
    let gDate, dateParts, timeParts, date;
    const isValidDateString = this.checkValidFormatString(inputTxt);
    if (!isValidDateString) { return; }
    if (this.configs['pickerType'] === 'both') {
      gDate = inputTxt.split(',');
      gDate = gDate.length === 1 ? inputTxt.split(' ') : gDate;
      dateParts = gDate[0].split('/');
      timeParts = gDate[1].split(':');

      date = new Date(+dateParts[2], +dateParts[1] - 1, dateParts[0], timeParts[0], timeParts[1]);
      // date = this.utils.formatDate(date, 'DD/MM/YYYY HH:mm');
    } else if (this.configs['pickerType'] === 'calendar') {
      dateParts = inputTxt.split('/');
      dateParts[2] = dateParts[2].split(' ')[0];
      date = new Date(+dateParts[2], +dateParts[1] - 1, dateParts[0]);
      // date = this.utils.formatDate(date, 'DD/MM/YYYY');
    } else if (this.configs['pickerType'] === 'timer') {
      dateParts = inputTxt.split(' ');
      timeParts = inputTxt.split(':');
      date = new Date(+today.getFullYear(), today.getMonth(), today.getDate(), timeParts[0], timeParts[1]);
      // date = this.utils.formatDate(date, 'HH:mm');
    }
    return date;
  }

  onBlurInput(event) {
    let date, day, month, year, getTotalDaysForMonth;
    // const formDate = this.configs['isGrid'] ? '' : this.formGroup.value[this.configs['id']];
    const inputTxt = this.configs['isGrid'] ? (event.currentTarget ? event.currentTarget.value : event.value) : event.currentTarget.value;
    const today = new Date();
    if (!inputTxt) {
      if (this.configs['isGrid']) {
        this.dateString = ' ';
      }
      return;
    } else if (inputTxt) {
      // if (this.configs['isGrid']) {
      date = this.getGridInputDate(inputTxt, today);
      if (!date) { return; }
    }

    let newDate = (date ? date : new Date(this.selectedDate));
    day = newDate.getDate();
    month = newDate.getMonth();
    year = newDate.getFullYear();

    if (day < 1) {
      newDate.setDate(1);
    } else if (day > getTotalDaysForMonth) {
      newDate.setDate(getTotalDaysForMonth);
    }

    if (month < 0) {
      newDate.setMonth(0);
    } else if (month > 12) {
      newDate.setMonth(11);
    }

    if (year > 9999) {
      newDate.setFullYear(2100);
    }
    if (this.configs['isGrid']) {
      this.dateString = this.utils.formatDate(newDate, this.configs['dateFormat']);
    } else {
      this.formGroup.controls[this.configs['id']].patchValue(newDate);
    }
    this.dateObj = undefined;
  }

  onFocus() {
    this.isInputFocused = true;
    if (!this.configs['isGrid']) {
      const dateObj = this.formGroup.value[this.configs['id']];
      // this.dateObj = dateObj ? new Date(dateObj) : '';
      this.selectedDate = dateObj ? new Date(+dateObj) : '';
    }
  }

  public myFilter = (d: Date): boolean => {
    const day = d.getDate();
    const month = d.getMonth();
    const getTotalDaysForMonth = new Date(d.getFullYear(), d.getMonth() + 1, 0).getDate();
    // Prevent Saturday and Sunday from being selected.
    return (day > 1 && day < getTotalDaysForMonth) && (month <= 12);
  }

  onKeyUp(event) {
    if (event.keyCode === 9) {
      this.onTabKeyEvent();
    } else if (event.keyCode === 37 || event.keyCode === 38 || event.keyCode === 39 || event.keyCode === 40) {
      // event.preventDefault();
      event.stopPropagation();
      // return false;
    }
  }

  onTabKeyEvent() {
    if (this.configs['isGrid']) {
      this.onItemChanged.next(this.dateString);
    }
  }

  onClickPicker() {
    // this.afterPickerOpened.emit();
  }

  ngOnInit() {
    this.defaultDt = this.configs['model'] ? this.configs['model'] : '';
    if (this.configs['pickerType'] === 'timer') {
      const date = new Date();
      if (this.configs['isGrid']) {
        const timeParts = this.configs['model'] ? this.configs['model'] : '';
        // if (timeParts) {
        //   date.setHours(parseInt(timeParts[0]));
        //   date.setMinutes(parseInt(timeParts[1]));
        //   this.configs['model'] = date;
        // }
      }
    }
    if (!this.configs['isGrid']) {
      const dateObj = this.formGroup.value[this.configs['id']];
      // this.dateObj = dateObj ? ne  w Date(dateObj) : '';
      this.selectedDate = dateObj ? this.utils.formatDate(dateObj) : '';
    }
  }

  ngOnDestroy() {
    this.configs['model'] = '';
    this.onItemChanged.unsubscribe();
  }

}
